import { produce } from 'immer';

import { DuplicateInternalBanner } from '../../../actions/bannersEdit/internal/duplicateInternalBanner';
import { selectEditPageItemNameEditorValue } from '../../../selectors/editPageItemNameEditor/editPageItemNameEditor';
import { getBannerEditPageItemEditorId } from '../../../service/BannerHelpers/BannerHelpers';
import { createInternalEditedBanner } from '../../../service/InternalBannerHelpers/InternalBannerHelpers';
import { InternalTemplateVars } from '../../../typings/internalBanners';
import { EditInternalBannersState } from '../../../typings/internalBannersEditState';
import { State } from '../../../typings/state';

export function duplicateInternalBanner(
    state: EditInternalBannersState,
    action: DuplicateInternalBanner,
    fullState: State
): EditInternalBannersState {
    return produce(state, draft => {
        const banner = draft.banners[action.bannerId];
        const bannersDraft = draft.bannersDraft[action.bannerId];

        if (!banner && !bannersDraft) {
            throw new Error(`cannot find banner for duplicate id:${action.bannerId}`);
        }

        const { editPageItemNameEditor: editors } = fullState;

        const editorData = selectEditPageItemNameEditorValue(editors, getBannerEditPageItemEditorId(action.bannerId));

        let description = banner.description;

        if (editorData.isVisible) {
            description = editorData.value;
        }

        const bannerId = action.newBannerId;
        const groupId = banner.group.id;
        const group = draft.groupBannersList[groupId];

        draft.banners[bannerId] = createInternalEditedBanner({
            id: bannerId,
            isNew: true,
            isDuplicateTemplate: banner.templateId !== '0',
            group: {
                id: group.groupId,
                name: group.groupName,
                status: group.status,
                canEdit: group.canEdit,
                type: group.type
            },
            campaign: group.campaign,
            description: description,
            templateId: banner.templateId,
            templateVars: banner.templateVars.reduce<InternalTemplateVars[]>((templateVars, templateVar) => {
                if (templateVar.templateId === banner.templateId) {
                    templateVars.push({
                        templateId: templateVar.templateId,
                        resourceId: templateVar.resourceId,
                        value: templateVar.value
                    });
                }

                return templateVars;
            }, [])
        });

        draft.bannersDraft[bannerId] = { ...bannersDraft };

        group.bannersIds.push(bannerId);
        group.bannersTotal += 1;
    });
}
